import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link", "middle", "short", "long"]

  connect() {
    this.connected = true
    this.measure()
    document.fonts.ready.then(() => {
      if (this.connected) this.measure()
    })

    try {
      if (window.sessionStorage.getItem("wordmark-introduced")) return
      window.sessionStorage.setItem("wordmark-introduced", "true")
    } catch {
      return
    }

    if (
      window.scrollY > 0 ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    )
      return

    this.introTimer = setTimeout(() => {
      this.expand()
      this.collapseTimer = setTimeout(() => this.hide(), 2750)
    }, 500)
  }

  disconnect() {
    this.connected = false
    this.hide()
  }

  measure() {
    const shortWidth = this.shortTarget.getBoundingClientRect().width
    const longWidth = this.longTarget.getBoundingClientRect().width
    const endWidth =
      this.linkTarget.getBoundingClientRect().width -
      this.middleTarget.getBoundingClientRect().width
    this.middleTarget.style.setProperty(
      "--reveal-short-width",
      `${shortWidth}px`,
    )
    this.middleTarget.style.setProperty("--reveal-long-width", `${longWidth}px`)
    this.fits = endWidth + longWidth <= this.element.clientWidth
    if (!this.fits) this.hide()
  }

  show(event) {
    if (event.type === "pointerenter" && event.pointerType !== "mouse") return
    if (event.type === "focusin" && !event.target.matches(":focus-visible"))
      return

    this.cancelIntroduction()
    if (event.type === "pointerenter") this.hovered = true
    if (event.type === "focusin") this.focused = true
    this.expand()
  }

  release(event) {
    if (event.type === "pointerleave") this.hovered = false
    if (event.type === "focusout") this.focused = false
    if (!this.hovered && !this.focused) this.hide()
  }

  expand() {
    this.measure()
    this.middleTarget.toggleAttribute("data-expanded", this.fits)
  }

  hide() {
    this.cancelIntroduction()
    this.hovered = false
    this.focused = false
    this.middleTarget.toggleAttribute("data-expanded", false)
  }

  cancelIntroduction() {
    clearTimeout(this.introTimer)
    clearTimeout(this.collapseTimer)
  }
}
